'use strict';

var React = require('react');
require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../Icon/Icon.js');
require('@sendsprint/api-types');
require('./assets/Ca.js');
require('./assets/Gb.js');
require('./assets/Gh.js');
require('./assets/Ke.js');
require('./assets/Ng.js');
require('./assets/Us.js');
require('./assets/Za.js');
require('./assets/None.js');
var components_Flag_utils_getFlagSvgByCountryInitials = require('./utils/getFlagSvgByCountryInitials.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Flag = ({ countryInitials, size = 24, ...props }) => {
    const flag = components_Flag_utils_getFlagSvgByCountryInitials.getFlagSvgByCountryInitials(countryInitials);
    return React__default['default'].createElement(components_Icon_Icon, Object.assign({ svg: flag, size: size }, props));
};

module.exports = Flag;
